// Cloud-setup resume intent (R1). When the user picks record location = cloud but has
// no active plan, they are sent to the account page to buy/claim a plan. That hop may
// bounce through the Stripe-hosted checkout (a full navigation away and back), so the
// intent is parked in sessionStorage (per-tab, survives the success_url round-trip to
// the same tab). On returning to the device settings screen the parked deviceId drives
// the resume that finishes with record_location = cloud.
//
// The same-SPA hop (attach on the account page → back to settings) additionally carries
// router location.state; either signal resumes. One deviceId at a time is sufficient.

const KEY = 'ls:pendingCloudLocation'; // value = deviceId awaiting location=cloud

export const cloudSetupIntent = {
  set(deviceId: string): void {
    try {
      sessionStorage.setItem(KEY, deviceId);
    } catch {
      /* storage unavailable (private mode / SSR) — router state still carries the SPA hop */
    }
  },
  get(): string | null {
    try {
      return sessionStorage.getItem(KEY);
    } catch {
      return null;
    }
  },
  clear(): void {
    try {
      sessionStorage.removeItem(KEY);
    } catch {
      /* ignore */
    }
  },
};
